export enum TocMode {
  OVER = "over",
  SIDE = "side"
}
